<template>
  <div v-if="page">
    <div
      class="card-group"
      v-for="category in page.academydocs"
      :key="category.title"
    >
      <h2 v-if="category.slug !== 'documents'" class="py-0 w-100">
        {{ category.title }}
      </h2>
      <div class="row">
        <div
          class="col-6 col-lg-4 col-xl-3"
          v-for="video in category.materials"
          :key="video.title"
        >
          <academy-youtube
            v-if="video.type === 'youtube'"
            :src="video.link"
            :title="video.title"
          />
          <academy-internal
            v-if="video.type === 'internal'"
            :title="video.title"
            :link="video.link"
            :img="video.img"
          />
          <academy-file
            v-if="video.type === 'file'"
            :title="video.title"
            :link="video.link"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AcademyYoutube from "@/components/Information/AcademyYoutube";
import gql from "graphql-tag";
import AcademyInternal from "@/components/Information/AcademyInternal";
import AcademyFile from "@/components/Information/AcademyFile";

export default {
  name: "Documents",
  components: {
    AcademyFile,
    AcademyInternal,
    AcademyYoutube,
  },
  data() {
    return {
      page: null,
    };
  },
  computed: {
    ...mapGetters({
      youtube: "academy/youtube",
    }),
  },
  apollo: {
    page: {
      query: gql`
        query {
          doc(id: "academy") {
            content
            title
          }
          academydocs {
            type
            title
            slug
            materials {
              type
              title
              link
              img
            }
          }
          viewer {
            id
            totals {
              tokens
            }
          }
          viewerIsAdmin
        }
      `,
      update: (data) => data,
      result({ data }) {
        if (data) {
          this.$store.commit("user/updateAvailable", {
            tokens: data.viewer.totals.tokens,
          });
          if (data.viewerIsAdmin) {
            this.$store.commit("user/setAdmin");
          }
        }
      },
    },
  },
};
</script>
